import { render, staticRenderFns } from "./SchemaKdzGoodsConfig.vue?vue&type=template&id=45333162"
import script from "./SchemaKdzGoodsConfig.vue?vue&type=script&lang=js"
export * from "./SchemaKdzGoodsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports